module.exports = __webpack_public_path__ + "static/media/gt-america-standard-light.e157c308.woff";